import * as React from 'react'
import { useState, useEffect } from 'react'
import { useContextSelector } from 'use-context-selector'
import {AppCurrencyContext, AppMainHotelsContext, AppMarketContext} from 'app/providers'

import { CommonFiltersItemsContextProvider } from './items'
import { CommonFiltersParityContextProvider } from './parity'
import { CommonFiltersAlertsContextProvider } from './alerts'
import {CommonFiltersSavedProvider} from "./SavedFilters";
import {isValidFutureDate} from "../@utils";
import {useAppMonthSelector} from "../../../@components/Header/MonthSelector/@hooks";

const Context = React.createContext({})

export function CommonFiltersContextProvider({defaultValues={}, children}) {

	const updateMainHotels = useContextSelector(AppMainHotelsContext, ({ updateState }) => updateState)
	const updateMarket = useContextSelector(AppMarketContext, ({ updateState }) => updateState)
    const updateCurrency = useContextSelector(AppCurrencyContext, ({ updateState }) => updateState)
    const { setMonthYear } = useAppMonthSelector()

	const { parity, items } = defaultValues

	const [state, setState] = useState({
		isLoading: false, open: true, openFilters: true
	})

	useEffect(() => {
		const { mainHotels, market, currency } = {...defaultValues}

		if (items?.dateRange && isValidFutureDate(items.dateRange)) setMonthYear({monthYear: items.dateRange})

        if (items?.dateRange === "custom") setMonthYear({monthYear: "custom"})

		mainHotels && updateMainHotels({mainHotels})

        currency && updateCurrency({currency})

		market && updateMarket({ market: market || null })

	}, [defaultValues])

	return <Context.Provider value={{state, setState}}>
		<CommonFiltersItemsContextProvider defaultValues={items}>
			<CommonFiltersParityContextProvider defaultValues={parity}>
				<CommonFiltersAlertsContextProvider>
                    <CommonFiltersSavedProvider>
                        {children}
                    </CommonFiltersSavedProvider>
				</CommonFiltersAlertsContextProvider>
			</CommonFiltersParityContextProvider>
		</CommonFiltersItemsContextProvider>
	</Context.Provider>
}

export { default as CommonFiltersItemsContext } from './items'
export { default as CommonFiltersParityContext } from './parity'
export { default as CommonFiltersAlertsContext } from './alerts'
export { default as CommonFiltersSavedContext } from './SavedFilters'

export default Context